<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="flex flex-row gap-2">
      <div class="w-1/3 pr-4">
        <prox-field label="On Issuance Limit Violation">
          <!-- <p-dropdown [disabled]="parent.isReadOnly()" [options]="programViolationRules" optionLabel="description"
            optionValue="id" [(ngModel)]="program.issuanceProgramViolationRuleId" [bzModel]="program"
            name="issuanceProgramViolationRuleId"></p-dropdown> -->
          <p-select [disabled]="parent.isReadOnly()" [options]="programViolationRules" optionLabel="description"
            optionValue="id" [(ngModel)]="program.issuanceProgramViolationRuleId" [bzModel]="program"
            name="issuanceProgramViolationRuleId" class="w-full"></p-select>
        </prox-field>
      </div>
    </div>
    <div class="flex grow">
      <p-tabView class="pt-3 grow w-full qb-tabview" [(activeIndex)]="tabViewIndex" (onChange)="onTabChange($event)">
        <p-tabPanel header="Program Issuance Limits">
          <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
            <ng-template pTemplate>
              <div class="flex flex-row grow">
                <div class="flex flex-col mb-2 grow">
                  <div class="flex mb-3 mt-3">
                    <p-button [disabled]="parent.isReadOnly() || !programIssuances" (click)="onPiAdd()" size="small"
                      label="Add Program Issuance Limit for Products and Services" icon="pi pi-plus"></p-button>
                  </div>
                  <p-splitter class="w-full h-full grow" layout="horizontal" styleClass="h-full"
                    [panelSizes]="[50, 50]">
                    <ng-template pTemplate>
                      <div class="w-full h-full mt-1 mb-2">
                        <prox-ag-grid gridId="programIssuanceLimitsGrid" [gridOptions]="piGridOptions"
                          [rowData]="programIssuances"></prox-ag-grid>
                      </div>
                    </ng-template>
                    <ng-template pTemplate>
                      <div class="w-full h-full mt-1 mb-2 flex flex-col">
                        <div class="qb-panel-title">Products in Selected Tag</div>
                        <prox-ag-grid class="grow" [gridOptions]="piTagProductGridOptions"
                          [rowData]="piTagProducts"></prox-ag-grid>
                      </div>
                    </ng-template>
                  </p-splitter>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate>
              <div class="flex w-full h-full grow gap-3">
                <div class="w-1/2 h-full">
                  <prox-ag-grid gridId="availablePiPugsGrid" [gridOptions]="piPugGridOptions"
                    [hasColSizeButtons]="false" [rowData]="availablePiPugs"></prox-ag-grid>
                </div>
                <div class="flex flex-col w-1/3 gap-2 mt-2">
                  <p-button [disabled]="parent.isReadOnly() || !selectedPi" (click)="onPiSelectAllGroups()" size="small"
                    label="Select All" icon="pi pi-check-square"></p-button>
                  <p-button [disabled]="parent.isReadOnly() || !selectedPi" (click)="onPiDeselectAllGroups()"
                    size="small" label="Deselect All" icon="pi pi-square" severity="secondary"></p-button>
                </div>
              </div>
            </ng-template>
          </p-splitter>
        </p-tabPanel>
        <!-- <p-tabPanel header="Kit Issuance Limits">
          <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
            <ng-template pTemplate>
              <div class="flex flex-row grow">
                <div class="flex flex-col mb-2 grow">
                  <div class="flex mb-3 mt-3">
                    <button [disabled]="parent.isReadOnly()" (click)="onKiAdd()" pButton type="button"
                      label="Add a Kit Issuance Limit" icon="pi pi-plus" class="p-button-sm"></button>
                  </div>
                  <div class="flex w-full h-full grow">
                    <div class="w-2/3 h-full mt-1 mb-2">
                      <prox-ag-grid [gridOptions]="kiGridOptions" [rowData]="kitIssuances"></prox-ag-grid>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate>
              <div class="flex w-full h-full grow gap-3">
                <div class="w-1/2 h-full">
                  <prox-ag-grid [gridOptions]="kiPugGridOptions" [rowData]="availableKiPugs"
                    [hasColSizeButtons]="false"></prox-ag-grid>
                </div>
                <div class="flex flex-col w-1/3 gap-2 mt-2">
                  <p-button [disabled]="parent.isReadOnly() || !selectedKi" (click)="onKiSelectAllGroups()" size="small"
                    label="Select All" icon="pi pi-check-square"></p-button>
                  <p-button [disabled]="parent.isReadOnly() || !selectedKi" (click)="onKiDeselectAllGroups()"
                    size="small" label="Deselect All" icon="pi pi-square" severity="secondary"></p-button>
                </div>
              </div>
            </ng-template>
          </p-splitter>
        </p-tabPanel> -->
        <p-tabPanel header="Account Issuance Limits">
          <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
            <ng-template pTemplate>
              <div class="flex flex-row grow">
                <div class="flex flex-col mb-2 grow">
                  <div class="flex mb-3 mt-3">
                    <button [disabled]="parent.isReadOnly()" (click)="onAiAdd()" pButton type="button"
                      label="Add Account Issuance Limit for Products and Services" icon="pi pi-plus"
                      class="p-button-sm"></button>
                  </div>
                  <p-splitter class="w-full h-full grow" layout="horizontal" styleClass="h-full"
                    [panelSizes]="[50, 50]">
                    <ng-template pTemplate>
                      <div class="w-full h-full mt-1 mb-2">
                        <prox-ag-grid [gridOptions]="aiGridOptions" [rowData]="accountIssuances"></prox-ag-grid>
                      </div>
                    </ng-template>
                    <ng-template pTemplate>
                      <div class="w-full h-full mt-1 mb-2 flex flex-col">
                        <div class="qb-panel-title">Products in Selected Tag</div>
                        <prox-ag-grid class="grow" [gridOptions]="aiTagProductGridOptions"
                          [rowData]="aiTagProducts"></prox-ag-grid>
                      </div>
                    </ng-template>
                  </p-splitter>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate>
              <div class="flex w-full h-full grow gap-3">
                <div class="w-1/2 h-full">
                  <prox-ag-grid [gridOptions]="aiPugGridOptions" [rowData]="availableAiPugs"
                    [hasColSizeButtons]="false"></prox-ag-grid>
                </div>
                <div class="flex flex-col w-1/3 gap-2 mt-2">
                  <p-button [disabled]="parent.isReadOnly() || !selectedAi" (click)="onAiSelectAllGroups()" size="small"
                    label="Select All" icon="pi pi-check-square"></p-button>
                  <p-button [disabled]="parent.isReadOnly() || !selectedAi" (click)="onAiDeselectAllGroups()"
                    size="small" label="Deselect All" icon="pi pi-square" severity="secondary"></p-button>
                </div>
              </div>
            </ng-template>
          </p-splitter>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>